import React, { useState } from 'react';
import { useTheme } from 'react-jss';
import PropTypes from 'prop-types';
import Box from '@/components/Box';
import Button from '@/components/Button';
import Icon from '@/components/Icon';
import Tabs from '@/components/Tabs';
import TabContent from '@/components/TabContent';
import cx from '@/utils/cx';
import useStyle from './style';

const Onboarding = ({
  onClose,
  prevBtn,
  nextBtn,
  children,
  buttonColor,
  lastStepButton,
  onPrev,
  onNext,
  ...rest
}) => {
  const [currentStepIndex, setCurrentStepIndex] = useState(0);
  const classes = useStyle();
  const theme = useTheme();

  function nextStep() {
    onNext(currentStepIndex);
    if (currentStepIndex === children.length - 1) {
      onClose();
    }
    setCurrentStepIndex((prev) => Math.min(prev + 1, children.length - 1));
  }

  function prevStep() {
    onPrev(currentStepIndex);
    setCurrentStepIndex((prev) => Math.max(prev - 1, 0));
  }

  return (
    <div className={classes.container}>
      <Tabs
        value={String(currentStepIndex)}
        onChange={(id) => setCurrentStepIndex(parseInt(id, 10))}
        _padding_bottom="xxl"
        _margin_bottom="xxl"
        swipe={false}
        {...rest}
      >
        {children.map((child) => <TabContent key={child.key} id={String(child.key)}>{child}</TabContent>)}
      </Tabs>
      <div
        _text_align={theme.direction.end}
        className={classes.pagination}
      >
        <Box _text_align="center">
          {children.map((child, index) => (
            <span
              key={child.key}
              className={cx(classes.stepDot, {
                [classes.activeDot]: currentStepIndex === index,
              })}
            />
          ))}
        </Box>

        {currentStepIndex !== 0 && (
          <Button
            invert
            onClick={prevStep}
            _col="6"
            _text_align={theme.direction.start}
            _background_color="background"
            _color={buttonColor}
          >
            <Icon
              src="https://passenger-pwa-cdn.snapp.ir/icons/chevron-right.svg"
              size={24}
              rotation={theme.direction.start === 'left' ? 180 : 0}
              _text_color={buttonColor}
            />
            {prevBtn}
          </Button>
        )}
        <Button
          invert
          onClick={nextStep}
          width="fill"
          _col="6"
          _text_align={theme.direction.end}
          _background_color="background"
          _color={buttonColor}
        >
          {currentStepIndex === children.length - 1 ? lastStepButton : nextBtn}
          <Icon
            rotation={theme.direction.start === 'left' ? 0 : 180}
            size={24}
            src="https://passenger-pwa-cdn.snapp.ir/icons/chevron-right.svg"
            _text_color={buttonColor}
          />
        </Button>
      </div>
    </div>
  );
};

Onboarding.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]).isRequired,
  onClose: PropTypes.func.isRequired,
  nextBtn: PropTypes.string,
  prevBtn: PropTypes.string,
  lastStepButton: PropTypes.string,
  buttonColor: PropTypes.string,
  onPrev: PropTypes.func,
  onNext: PropTypes.func,
};

Onboarding.defaultProps = {
  nextBtn: '',
  prevBtn: '',
  lastStepButton: '',
  buttonColor: 'primary',
  onPrev: () => {},
  onNext: () => {},
};

export default Onboarding;
